import React from 'react'
import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getNewsList} from '../../../apis/news/getNewsList'

const useQueryNewsList = () => {
    const PAGE_SIZE = 10
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.news.getNews(),
        queryFn: async () => {
            const {data} = await getNewsList()
            return data
        },
        refetchOnWindowFocus: false,
    })
    return {data, refetch}
}

export default useQueryNewsList
